const headers = {
  name: "Purchases Invoice",
  navigate: {
    path: [
      {
        name: "Purchases",
        path: "/app/purchases",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
